// React Query queries for AI-powered email generation

import { useApiClient } from '@commander/api-client';
import { useQuery } from '@tanstack/react-query';
import { createEmailAiApi } from '../../api/emailAiApi';
import { communicationKeys } from '../communicationKeys';

/**
 * Hook to fetch AI generation result for emails
 * @param generationId - ID of the generation to fetch
 * @param options - Query options including enabled flag
 */
export function useEmailAiGeneration(generationId: string, options?: { enabled?: boolean }) {
  const apiClient = useApiClient();
  const emailAiApi = createEmailAiApi(apiClient);

  return useQuery({
    queryKey: communicationKeys.aiGenerations.detail(generationId),
    queryFn: () => emailAiApi.getGeneration(generationId),
    enabled: options?.enabled !== false && !!generationId,
  });
}
